import { render, staticRenderFns } from "./particlesJS.vue?vue&type=template&id=06ebded2&scoped=true"
import script from "./particlesJS.vue?vue&type=script&lang=js"
export * from "./particlesJS.vue?vue&type=script&lang=js"
import style0 from "./particlesJS.vue?vue&type=style&index=0&id=06ebded2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebded2",
  null
  
)

export default component.exports